module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/173e52e04ff6f2036add0558812948e6.gif";